import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-text-with-logo',
  templateUrl: 'text-with-logo.component.html',
  styleUrls: ['text-with-logo.component.scss']
})
export class TextWithLogoComponent {

  // TODO -- will hold the an identifiable variable to locate the logo of the organization
  @Input()
  text!: string

  @Input()
  logo!: string

  @Input()
  size: 'x-small' | 'small' | 'medium' | 'large' = 'small'

  @Input()
  color!: string

  @Input()
  chips!: string[]

}
